import React from 'react';
import ReactDOM from 'react-dom';
import './scss/index.scss';
import './scss/home.scss';
import './scss/top-menu.scss';
import './scss/bill.scss';
import './scss/productsGrid.scss';
import './scss/order.scss';
import './scss/print.scss';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js